module.exports = __webpack_public_path__ + "static/media/ic_ruzhu_brand@2x.7903a974.png";